import React, { useEffect, useState } from "react";
import { abpnClient } from "../Services/AbpnClient";
import { PreCertUser } from "../Shared/Models/PreCertUser";
import { deepCopy } from "../Shared/Utility/DeepCopy";
import { IsErrorPage } from "../Shared/Utility/PreCertLocationHelper";
import { AuthContext } from "./AuthProvider";

interface IProfileProviderProps {
    user: PreCertUser,
    updateSelectedTrainingProgramId: (selectedTrainingProgramId: number) => void
}
export const ProfileContext = React.createContext<IProfileProviderProps>(null);

export const ProfileProvider = (props: any) => {
    const [user, setUser] = useState<PreCertUser>(null);
    var auth = React.useContext(AuthContext);

    const updateSelectedTrainingProgramId = (selectedTrainingProgramId: number) => {
        const updated = deepCopy(user);
        localStorage.setItem("trainingProgramId", selectedTrainingProgramId.toString());
        updated.selectedTrainingProgramId = selectedTrainingProgramId;
        auth.currentUser = updated;
        setUser(updated);
    }

    useEffect(() => {
        const loadUser = async () => {
            let savedTrainingProgramId = parseInt(localStorage.getItem("trainingProgramId"));
            let userResult = await abpnClient.get<PreCertUser>("/api/profile/getcurrentuser", auth);
    
            if (!userResult.trainingPrograms.find((_: any) => _.trainingProgramId === savedTrainingProgramId)) {
                savedTrainingProgramId = userResult.trainingPrograms[0].trainingProgramId;
                localStorage.setItem("trainingProgramId", userResult.trainingPrograms[0].trainingProgramId.toString());
            }

            userResult.selectedTrainingProgramId = savedTrainingProgramId;

            if (userResult.preCertUserId !== user?.preCertUserId) {
                auth.currentUser = userResult;
                setUser(userResult);
            }
        }

        if (auth.isAuthenticated() && !IsErrorPage()) {
            loadUser();
        }
    }, [user])

    return <ProfileContext.Provider value={{user, updateSelectedTrainingProgramId}}> { props.children }</ ProfileContext.Provider>;
}